import { useMutation } from '@tanstack/react-query';

import { obtainAuthenticationEmail } from '@api';

export const useObtainAuthenticationEmail = (options: object = {}) => {
  return useMutation({
    mutationFn: (values: AuthEmailCredentialsType) =>
      obtainAuthenticationEmail(values),
    ...options,
  });
};
